import {Controller} from "@hotwired/stimulus"

// Reveals the BlaulichtSMS "Kunu" field (BlaulichtSMS only) and the consent
// checkbox (any real provider, i.e. not "none"/blank). Reconnects on turbo:morph
// so a 422 re-render keeps working.
export class AlarmOrderAppAlertingController extends Controller {
  static targets = ["radio", "kunu", "consent"]

  connect() {
    this.refresh = this.refresh.bind(this)
    window.addEventListener("turbo:morph", this.refresh)
    this.refresh()
  }

  disconnect() {
    window.removeEventListener("turbo:morph", this.refresh)
  }

  refresh() {
    const value = this.radioTargets.find((radio) => radio.checked)?.value
    this.kunuTarget.hidden = value !== "blaulicht_sms"
    this.consentTarget.hidden = !value || value === "none"
  }
}
